import store from "@/store";
import { ElMessageBox } from "element-plus";
import bus from "@/bus";
import { useRouter } from "vue-router";

let info: any = localStorage.getItem("loginInfo") || '';
let loginInfo:any = {}

if (typeof info === "string") {
  loginInfo = info
}else {
  loginInfo = JSON.parse(info) || {};
}

export const checkDeadDatetime = () => {
  if (store.getters.loginId) {
    const router = useRouter();
    let nowDate = new Date().getTime();
    let dead_datetime = loginInfo.saas_dead_datetime;
    const diff = new Date(dead_datetime).getTime() - nowDate;
    const timeDiff = Math.floor(diff / 1000 / 60 / 1440);
    if (timeDiff < 0) {
      ElMessageBox.alert("账户已过期");
      store.dispatch("clearInfo").then((res) => {
        router.push({ name: "Login" });
      });
      localStorage.removeItem("login_id");
    } else if (timeDiff <= 5) {
      ElMessageBox.confirm(`账户还有${timeDiff}天到期，是否续费?`, "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          bus.emit("renewal", true);
        })
        .catch(() => {
          bus.emit("renewal", false);
        });
    }
  }
};
